import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  SimpleGrid,
  Image,
  Text,
  useDisclosure,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { supabase } from "../../lib/supabaseClient";
import { useAuth } from "../../context/AuthContext";
import LabelModal from "../modals/LabelModal";

const LabelTab = () => {
  const { user } = useAuth();
  const [labels, setLabels] = useState([]);
  const {
    isOpen: isLabelModalOpen,
    onOpen: onLabelModalOpen,
    onClose: onLabelModalClose,
  } = useDisclosure();

  // 레이블 데이터 가져오기
  useEffect(() => {
    const fetchLabels = async () => {
      const { data, error } = await supabase
        .from("label")
        .select("logo, name, description")
        .eq("user", user.email)
        .order("created_date", { ascending: false });

      if (error) {
        console.error("Error fetching labels:", error);
        return;
      }
      setLabels(data);
    };

    if (user) fetchLabels();
  }, [user]);

  // 레이블 데이터 새로고침 함수
  const refreshLabels = async () => {
    if (!user) return;

    const { data, error } = await supabase
      .from("label")
      .select("logo, name, description")
      .eq("user", user.email)
      .order("created_date", { ascending: false });

    if (error) {
      console.error("Error fetching labels:", error);
      return;
    }
    setLabels(data);
  };

  return (
    <>
      <SimpleGrid columns={[1, 2, 3, 4]} spacing={6} p={4}>
        <Box
          as={Button}
          variant="outline"
          height="300px"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          borderWidth="2px"
          borderStyle="dashed"
          borderRadius="xl"
          borderColor="blue.200"
          _hover={{
            borderColor: "blue.400",
            bg: "blue.50",
            transform: "scale(1.02)",
            transition: "all 0.2s",
          }}
          onClick={onLabelModalOpen}
        >
          <Icon as={AddIcon} boxSize={8} color="blue.400" mb={2} />
          <Text color="blue.600" fontWeight="medium">
            새 레이블 추가
          </Text>
        </Box>

        {labels.map((label, index) => (
          <Box
            key={index}
            height="300px"
            borderWidth="1px"
            borderRadius="xl"
            overflow="hidden"
            position="relative"
            bg="white"
            boxShadow="md"
            _hover={{
              boxShadow: "lg",
              transform: "translateY(-4px)",
              transition: "all 0.2s",
            }}
          >
            <Box height="200px" position="relative" overflow="hidden">
              <Image
                src={label.logo}
                alt={label.name}
                objectFit="contain"
                height="100%"
                width="100%"
                bg="gray.50"
                fallback={
                  <Box
                    height="100%"
                    width="100%"
                    bg="gray.100"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text color="gray.400">이미지 없음</Text>
                  </Box>
                }
              />
            </Box>

            <Box p={4}>
              <Text
                fontSize="xl"
                fontWeight="bold"
                color="gray.700"
                mb={2}
                noOfLines={1}
              >
                {label.name}
              </Text>
              <Text
                fontSize="sm"
                color="gray.500"
                noOfLines={2}
                height="40px"
                overflow="hidden"
              >
                {label.description || "설명 없음"}
              </Text>
            </Box>
          </Box>
        ))}
      </SimpleGrid>

      <LabelModal
        isOpen={isLabelModalOpen}
        onClose={onLabelModalClose}
        onSuccess={refreshLabels}
      />
    </>
  );
};

export default LabelTab;
